import React from 'react';
import { AlertCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ['My resin stays sticky or tacky after 24 hours', 'I keep getting micro-bubbles that ruin the finish', 'I waste expensive material on failed attempts', "I don't know what went wrong when it fails"];
  return <section className="py-20 bg-stone-900 text-stone-50" data-id="element-81">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-82">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-white" data-id="element-83">
          Does This Sound Like You?
        </h2>

        <div className="grid gap-4 mb-12 text-left" data-id="element-84">
          {pains.map((pain, idx) => <div key={idx} className="flex items-center gap-4 bg-stone-800/50 p-4 rounded-xl border border-stone-700" data-id="element-85">
              <div className="w-8 h-8 rounded-full bg-red-500/20 flex items-center justify-center flex-shrink-0" data-id="element-86">
                <AlertCircle className="w-5 h-5 text-red-400" data-id="element-87" />
              </div>
              <span className="text-lg md:text-xl text-stone-200" data-id="element-88">{pain}</span>
            </div>)}
        </div>

        <div className="bg-stone-800 p-8 rounded-2xl border border-stone-700" data-id="element-89">
          <p className="text-xl md:text-2xl font-serif italic text-teal-200" data-id="element-90">
            "It’s not your creativity. It’s the missing system."
          </p>
        </div>
      </div>
    </section>;
}